import React, { useEffect, useState } from "react";
import DefaultLayout from "../../layouts/defaultLayout";
import BurdCrumbs from "../../components/burdCrumbs";
import TableLayout from "../../components/table";
import Modal from "../../components/modal";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../../constants";
import axios from "axios";
import { toast } from "react-toastify";
import { Loader } from "rsuite";
import { Input } from "../../components/form-elements";
import { addition } from "../../assets/svgIcons";
import { userData } from "../../data/fake_login_data";
import { perms } from "../../data/side_nav_data";
import { exportToCSV } from "../../functions";
const Universities = () => {
  const navigate = useNavigate();
  const [searchHeaderKet, setSearchHeaderKey] = useState("");
  const [showAdd, setShowAdd] = useState(false);
  const [hiddenId, setHiddenId] = useState(false);
  const [universityName, setUniversityName] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(false);
  const [deleteId, setDeleteId] = useState(false);
  const [editId, setEditId] = useState(false);
  const [opened, setOpened] = useState(null);
  const headers = [
    {
      label: "ID",
      dataIndex: "university_id",
      search: true,
      sort: true,
      equal: true,
    },
    // {
    //   label: "Subscriptions",
    //   type: "children",
    //   children: ({ headers, row }) => {
    //     return (
    //       <div>
    //         <button
    //           className="btn btn-primary"
    //           onClick={() =>
    //             navigate("/students", {
    //               state: { university_id: row?.university_id },
    //             })
    //           }
    //         >
    //           Show
    //         </button>
    //       </div>
    //     );
    //   },
    // },
    // {
    //   label: "Posts",
    //   type: "children",
    //   children: ({ headers, row }) => {
    //     return (
    //       <div>
    //         <button
    //           className="btn btn-primary"
    //           onClick={() =>
    //             navigate("/posts", {
    //               state: { university_id: row?.university_id },
    //             })
    //           }
    //         >
    //           Posts
    //         </button>
    //       </div>
    //     );
    //   },
    // },
    // {
    //   label: "Material",
    //   type: "children",
    //   children: ({ headers, row }) => {
    //     return (
    //       <div>
    //         <button
    //           className="btn btn-primary"
    //           onClick={() =>
    //             navigate("/chains", {
    //               state: {
    //                 university_id: row?.university_id,
    //                 university_name: row?.university_name,
    //               },
    //             })
    //           }
    //         >
    //           Show
    //         </button>
    //       </div>
    //     );
    //   },
    // },
    perms?.includes("*1_5") || perms?.startsWith("1_5")
      ? {
          label: "Subscriptions",
          type: "children",
          children: ({ headers, row }) => {
            return (
              <div>
                <button
                 className="flex items-center space-x-2 px-4 py-2 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-lg hover:from-blue-600 hover:to-purple-700 transition-all duration-200 shadow-md hover:shadow-lg transform hover:scale-105"
                  onClick={() =>
                    navigate("subscription", {
                      state: {
                        university_id: row?.university_id,
                        university_name: row?.university_name,
                      },
                    })
                  }
                >
                 <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                 </svg>
                 <span className="font-medium">Show</span>
                </button>
              </div>
            );
          },
        }
      : {},
    perms?.includes("*2_1") || perms?.startsWith("2_1")
      ? {
          label: "Grades",
          type: "children",
          children: ({ headers, row }) => {
            return (
              <div>
                <button
                 className="flex items-center space-x-2 px-4 py-2 bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-lg hover:from-green-600 hover:to-emerald-700 transition-all duration-200 shadow-md hover:shadow-lg transform hover:scale-105"
                  onClick={() =>
                    navigate("grades", {
                      state: { university_id: row?.university_id },
                    })
                  }
                >
                 <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
                 </svg>
                 <span className="font-medium">Show</span>
                </button>
              </div>
            );
          },
        }
      : {},
    {
      label: "university_name",
      dataIndex: "university_name",
      search: true,
      sort: true,
    },
    // {
    //   label: "college_name",
    //   dataIndex: "college_name",
    // },
    {
      label: "Current status",
      type: "children",
      children: ({ row }) => {
        if (row.hide == "false") {
          return <span className="text-success textCurrent">Active</span>;
        } else {
          return <span className="text-danger textCurrent">Inactive</span>;
        }
      },
    },
    perms?.includes("*1_3") || perms?.startsWith("1_3")
      ? {
          label: "Actions",
          type: "children",
          children: ({ headers, row, index, lastIndex }) => {
            return (
              <div className="menu_Open_close">
                <div
                  className="open_close"
                  style={{ cursor: "pointer", color: "black" }}
                  onClick={() =>
                    setOpened(
                      opened == row?.university_id ? null : row?.university_id
                    )
                  }
                >
                  <img
                    src="https://res.cloudinary.com/duovxefh6/image/upload/v1701489400/menu_hrpzcb.png"
                    alt=""
                    style={{ width: "20px", height: "20px" }}
                  />
                </div>
                {row?.university_id == opened ? (
                  <div
                    className={
                      index == lastIndex - 1 ||
                      index == lastIndex - 2 ||
                      index == lastIndex - 3
                        ? "actions-views row-actions-view"
                        : "actions-views column-actions-view"
                    }
                  >
                    {/* <button
                  className="btn btn-danger"
                  style={{ marginRight: "10px" }}
                  onClick={() => {
                    setDeleteId(row);
                  }}
                >
                  Delete
                </button> */}
                    {perms?.includes("*1_3") || perms?.startsWith("1_3") ? (
                      <button
                       className="flex items-center space-x-2 px-4 py-2 bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-lg hover:from-blue-600 hover:to-indigo-700 transition-all duration-200 shadow-md hover:shadow-lg transform hover:scale-105"
                        onClick={() => {
                          setEditId(row);
                        }}
                      >
                       <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                       </svg>
                       <span className="font-medium">Edit</span>
                      </button>
                    ) : null}
                    {/* setEditId */}
                  </div>
                ) : null}
              </div>
            );
          },
        }
      : {},
    perms?.includes("*1_4") || perms?.startsWith("1_4")
      ? {
          label: "Change status",
          type: "children",
          children: ({ row }) => {
            if (row.hide !== "false") {
              return (
               <button
                 className="flex items-center space-x-2 px-4 py-2 bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-lg hover:from-green-600 hover:to-emerald-700 transition-all duration-200 shadow-md hover:shadow-lg transform hover:scale-105"
                  onClick={() =>
                    setHiddenId({
                      university_id: row?.university_id,
                      university_name: row?.university_name,
                      status: "false",
                    })
                  }
                >
                 <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                 </svg>
                 <span className="font-medium">Active</span>
               </button>
              );
            } else {
              return (
               <button
                 className="flex items-center space-x-2 px-4 py-2 bg-gradient-to-r from-red-500 to-pink-600 text-white rounded-lg hover:from-red-600 hover:to-pink-700 transition-all duration-200 shadow-md hover:shadow-lg transform hover:scale-105"
                  onClick={() =>
                    setHiddenId({
                      university_id: row?.university_id,
                      university_name: row?.university_name,
                      status: "true",
                    })
                  }
                >
                 <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
                 </svg>
                 <span className="font-medium">Inactive</span>
               </button>
              );
            }
          },
        }
      : {},

    // setHiddenId
  ];

  useEffect(() => {
    fetchData();
  }, []);
  window.addEventListener("click", (e) => {
    if (
      opened &&
      !e.target?.classList?.contains("actions-views") &&
      !e.target?.parentNode?.classList?.contains("open_close")
    ) {
      setOpened(null);
    }
  });
  const fetchData = async () => {
    try {
      const response = await axios.post(
        BASE_URL + "universities/select_universitiesR.php",
        {
          admin_id: userData?.user_id,
          access_token: userData?.access_token,
        }
      );
      setData(response?.data?.message);
    } catch (err) {
      setData([]);
      toast.error(err?.message);
    }
  };
  const addUniversity = async (e) => {
    e.preventDefault();
    setLoading(true);
    const form = e.target;

    try {
      const response = await axios.post(
        BASE_URL + "universities/insert_university.php",
        {
          university_name: universityName?.value,
          admin_id: userData?.user_id,
          access_token: userData?.access_token,
        }
      );

      if (response.data?.status == "success") {
        toast.success(response.data?.message);
        fetchData();
        setShowAdd(false);
        form.reset();
        setLoading(false);
      } else {
        setLoading(false);
        toast.error(response.data?.message);
      }

      // setShowAdd(false);
    } catch (err) {
      toast.error(err?.message);
      setLoading(false);
    }
  };
  const handleDeleteUniversity = () => {
    const data_send = {
      university_id: deleteId?.university_id,
      admin_id: userData?.user_id,
      access_token: userData?.access_token,
    };
    axios
      .post(
        BASE_URL + "universities/delete_university.php",
        JSON.stringify(data_send)
      )
      .then((res) => {
        if (res.data.status == "success") {
          toast.success(res.data.message);
          setDeleteId(false);
          fetchData();
        } else if (res.data.status == "error") {
          toast.error(res.data.message);
        } else {
          toast.error("Something Went Error");
        }
      });
  };
  const handleEditUniversity = (e) => {
    e.preventDefault();
    console.log(editId?.university_id);
    const data_send = {
      university_id: editId?.university_id,
      university_name: editId?.university_name,

      admin_id: userData?.user_id,
      access_token: userData?.access_token,
    };
    try {
      axios
        .post(BASE_URL + "universities/edit_university_name.php", data_send)
        .then((res) => {
          if (res.data.status == "success") {
            toast.success(res.data.message);
            setEditId(false);
            fetchData();
          } else if (res.data.status == "error") {
            toast.error(res.data.message);
          } else {
            toast.error("Something Went Error");
          }
        });
    } catch (e) {
      console.log(e);
    }
  };
  const hideUniv = async () => {
    setLoading(true);

    try {
      const response = await axios.post(
        BASE_URL + "universities/show_hide_university.php",
        {
          university_id: hiddenId?.university_id,
          status: hiddenId?.status,
          admin_id: userData?.user_id,
          access_token: userData?.access_token,
        }
      );
      if (response.data?.status == "success") {
        toast.success(response.data?.message);
        fetchData();
        setHiddenId(false);
        setLoading(false);
      } else {
        setLoading(false);
        toast.error(response.data?.message);
      }

      // setShowAdd(false);
    } catch (err) {
      toast.error(err?.message);
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      <DefaultLayout
        setSearchHeaderKey={setSearchHeaderKey}
        children={
          <div className="space-y-6">
            {/* Beautiful Page Header */}
            <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-6">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-gradient-to-r from-blue-500 to-purple-600 rounded-xl flex items-center justify-center shadow-lg">
                    <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                    </svg>
                  </div>
                  <div>
                    <h1 className="text-2xl font-bold text-gray-900">Universities</h1>
                    <p className="text-gray-600 text-sm">Manage university information and settings</p>
                  </div>
                </div>

                <div className="flex items-center space-x-3">
                  {/* Export Button */}
                  {(perms?.includes("*17_1") || perms?.startsWith("17_1")) && data?.length ? (
                <button
                      className="flex items-center space-x-2 px-4 py-2.5 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-all duration-200 shadow-md hover:shadow-lg"
                onClick={() => {
                  exportToCSV(data, "University Data");
                }}
              >
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                      </svg>
                      <span className="font-medium">Export</span>
                    </button>
                  ) : null}

                  {/* Add University Button */}
                  {perms?.includes("*1_2") || perms?.startsWith("1_2") ? (
                    <button
                      className="flex items-center space-x-2 px-6 py-2.5 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-lg hover:from-blue-700 hover:to-purple-700 transition-all duration-200 shadow-md hover:shadow-lg"
                      onClick={() => setShowAdd(true)}
                    >
                      <div className="w-5 h-5 flex items-center justify-center">
                        {addition}
                      </div>
                      <span className="font-medium">Add University</span>
              </button>
            ) : null}
                </div>
              </div>
            </div>

            {/* Statistics Cards */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-6">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-gray-600">Total Universities</p>
                    <p className="text-3xl font-bold text-gray-900">{data?.length || 0}</p>
                  </div>
                  <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center">
                    <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                    </svg>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-6">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-gray-600">Active Universities</p>
                    <p className="text-3xl font-bold text-green-600">
                      {data && data?.length && data?.filter(item => item.status === "true").length || 0}
                    </p>
                  </div>
                  <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center">
                    <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-6">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-gray-600">Inactive Universities</p>
                    <p className="text-3xl font-bold text-red-600">
                      {data && data?.length && data?.filter(item => item.status === "false").length || 0}
                    </p>
                  </div>
                  <div className="w-12 h-12 bg-red-100 rounded-xl flex items-center justify-center">
                    <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>

            {/* Table */}
            <TableLayout
              searchHeaderKet={searchHeaderKet}
              headers={headers}
              data={data}
            />
          </div>
        }
      />
      <Modal
        headerTitle={"Add University"}
        open={showAdd}
        toggle={setShowAdd}
        children={
          <div className="p-6">
          <form
            action="#"
            onSubmit={!loading ? addUniversity : (e) => e.preventDefault()}
              className="space-y-6"
            >
              <div className="space-y-2">
                <label htmlFor="university_name" className="block text-sm font-medium text-gray-700">
                  University Name
                </label>
              <Input
                type={"text"}
                id={"university_name"}
                name={"university_name"}
                onChange={setUniversityName}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
              />
            </div>

              <div className="flex justify-end space-x-3 pt-4">
                <button
                  type="button"
                  onClick={() => setShowAdd(false)}
                  className="px-6 py-2.5 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-all duration-200 font-medium"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="flex items-center space-x-2 px-6 py-2.5 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-lg hover:from-blue-700 hover:to-purple-700 transition-all duration-200 font-medium shadow-md hover:shadow-lg"
                >
                  {!loading ? (
                    <>
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                      <span>Save University</span>
                    </>
                  ) : (
                    <Loader size="sm" />
                  )}
            </button>
              </div>
          </form>
          </div>
        }
      />
      <Modal
        open={hiddenId}
        toggle={setHiddenId}
        headerTitle={"Show / Hide University"}
        children={
          <div className="p-6">
            <div className="text-center space-y-4">
              <div className="w-16 h-16 mx-auto bg-orange-100 rounded-full flex items-center justify-center">
                <svg className="w-8 h-8 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.5 0L4.268 18.5c-.77.833.192 2.5 1.732 2.5z" />
                </svg>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  {hiddenId?.status == "true" ? "Activate" : "Deactivate"} University
                </h3>
                <p className="text-gray-600">
                  Are you sure you want to{" "}
                  <span className="font-medium">
                    {hiddenId?.status == "true" ? "activate" : "deactivate"}
                  </span>{" "}
                  <span className="font-semibold text-gray-900">
                    {hiddenId?.university_name}
                  </span>?
                </p>
              </div>
            </div>

            <div className="flex justify-center space-x-3 mt-8">
              <button
                className="px-6 py-2.5 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-all duration-200 font-medium"
                onClick={() => {
                  setHiddenId(false);
                }}
              >
                Cancel
              </button>
              <button
                className={`px-6 py-2.5 text-white rounded-lg transition-all duration-200 font-medium shadow-md hover:shadow-lg ${hiddenId?.status == "true"
                    ? "bg-green-600 hover:bg-green-700"
                    : "bg-red-600 hover:bg-red-700"
                  }`}
                onClick={() => {
                  return !loading ? hideUniv() : null;
                }}
              >
                {!loading ? (
                  <>
                    {hiddenId?.status == "true" ? "Activate" : "Deactivate"}
                  </>
                ) : (
                  <Loader size="sm" />
                )}
              </button>
            </div>
          </div>
        }
      />
      <Modal
        open={deleteId}
        toggle={setDeleteId}
        headerTitle={"Delete University"}
        children={
          <div className="p-6">
            <div className="text-center space-y-4">
              <div className="w-16 h-16 mx-auto bg-red-100 rounded-full flex items-center justify-center">
                <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  Delete University
                </h3>
                <p className="text-gray-600">
                  Are you sure you want to delete{" "}
                  <span className="font-semibold text-gray-900">
                    {deleteId?.university_name}
                  </span>?
                </p>
                <p className="text-sm text-red-600 mt-2">
                  This action cannot be undone.
                </p>
              </div>
            </div>

            <div className="flex justify-center space-x-3 mt-8">
              <button
                className="px-6 py-2.5 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-all duration-200 font-medium"
                onClick={() => {
                  setDeleteId(false);
                }}
              >
                Cancel
              </button>
              <button
                className="px-6 py-2.5 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-all duration-200 font-medium shadow-md hover:shadow-lg"
                onClick={() => {
                  handleDeleteUniversity();
                }}
              >
                Delete University
              </button>
            </div>
          </div>
        }
      />

      <Modal
        headerTitle={"Edit University"}
        open={editId}
        toggle={setEditId}
        children={
          <div className="p-6">
          <form
            action="#"
            onSubmit={
              !loading ? handleEditUniversity : (e) => e.preventDefault()
            }
              className="space-y-6"
            >
              <div className="space-y-2">
                <label htmlFor="university_name" className="block text-sm font-medium text-gray-700">
                  University Name
                </label>
              <Input
                type={"text"}
                id={"university_name"}
                name={"university_name"}
                defaultValue={editId?.university_name}
                onChange={(e) =>
                  setEditId({ ...editId, university_name: e.value })
                }
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
              />
            </div>

              <div className="flex justify-end space-x-3 pt-4">
                <button
                  type="button"
                  onClick={() => setEditId(false)}
                  className="px-6 py-2.5 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-all duration-200 font-medium"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="flex items-center space-x-2 px-6 py-2.5 bg-gradient-to-r from-green-600 to-emerald-600 text-white rounded-lg hover:from-green-700 hover:to-emerald-700 transition-all duration-200 font-medium shadow-md hover:shadow-lg"
                >
                  {!loading ? (
                    <>
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                      </svg>
                      <span>Update University</span>
                    </>
                  ) : (
                    <Loader size="sm" />
                  )}
            </button>
              </div>
          </form>
          </div>
        }
      />
    </div>
  );
};

export default Universities;
